import styled from "styled-components";

export const LoadingState = styled.div`
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-size: 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #6c757d;

  h4 {
    margin-bottom: 0.5rem;
    color: #495057;
  }
`;

export const ErrorState = styled.div`
  background: #f8d7da;
  color: #721c24;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  border: 0.125rem solid #f5c6cb;
`;

export const SuccessState = styled.div`
  background: #d4edda;
  color: #155724;
  padding: 0.75rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  border: 0.125rem solid #c3e6cb;
`;
